class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.variant = this.variant ?? JSON.parse(this.querySelector('variant-selects [data-selected-variant]')?.innerHTML);

    this.sizeOptions  = [...this.querySelectorAll('fieldset[data-name="Size"] label, fieldset[data-name="مقاس"] label')];
    this.colorOptions = [...this.querySelectorAll('fieldset[data-name="Color"] label, fieldset[data-name="لون"] label')];
  }

  connectedCallback() {
    const section = this.closest('section');
    const productInfo = this.closest('product-info');
    const selectBtn = productInfo?.querySelector('.btn-select-size');
    const sizePopup = productInfo?.querySelector('.size-secection');
    const closeBtn = productInfo?.querySelector('.close-size');

    // Restore last-picked size
    if (window.sizeSelected) {
      console.log(window.sizeSelected,"window.sizeSelected")
      //const field = this.querySelector(`fieldset[data-name="Size"] input[value="${window.sizeSelected}"]`);
      const field = this.querySelector(
  `fieldset[data-name="Size"] input[value="${window.sizeSelected}"], 
   fieldset[data-name="مقاس"] input[value="${window.sizeSelected}"]`
);
      if (field) field.checked = true;
    }

    // Clone blocks for mobile
    this.linkedTo = [...productInfo.querySelectorAll('[data-linked-to]')];
    this.linkedTo.forEach(block => {
      const toClone = this.querySelector(`fieldset[data-name="${block.dataset.linkedTo}"]`).cloneNode(true);
      let name = block.dataset.linkedTo;
      if (htmlEl.lang === "ar" && htmlEl.dir === "rtl") {
        if (name === 'لون' || name === 'Color') {
          name = 'color';
        }
      } else {
      name = name.toLowerCase();
      }
      this[`${name}Options`] = [
        ...(this[`${name}Options`] || []),
        ...toClone.querySelectorAll('label')
      ];
      toClone.querySelectorAll('[id]').forEach(el => {
        el.id += 'cloned';
        el.name += 'cloned';
      });
      block.innerHTML = '';
      [...toClone.childNodes].reverse().forEach(n => toClone.append(n));
      block.appendChild(toClone);
    });

  // REPLACE WITH
    // ✅ Assign loader early — showLoader() in the change handler needs it
    this.loader = productInfo.querySelector('.loader');

    const _selectedVariantData = JSON.parse(
      this.querySelector('[data-selected-variant]')?.innerHTML || 'null'
    );
    const _pendingColor = _selectedVariantData?.options?.[1];

    const runInitWithColorRestore = () => {
      if (!this.dataset.combined) {
        // ✅ skipFilter=true — we handle filterOptions ourselves after re-cloning
        window.injectMissingColorSwatches?.(true);

        // ✅ Re-clone mobile color fieldset AFTER injection so it includes the new swatches
        this.linkedTo?.forEach(linkedBlock => {
          const fieldsetName = linkedBlock.dataset.linkedTo;
          if (fieldsetName !== 'Color' && fieldsetName !== 'لون') return;
          const sourceFieldset = this.querySelector(`fieldset[data-name="${fieldsetName}"]`);
          if (!sourceFieldset) return;
          const toClone = sourceFieldset.cloneNode(true);
          toClone.querySelectorAll('[id]').forEach(el => {
            el.id += 'cloned';
            el.name += 'cloned';
          });
          linkedBlock.innerHTML = '';
          [...toClone.childNodes].reverse().forEach(n => toClone.append(n));
          linkedBlock.appendChild(toClone);
        });

        // Restore checked color before filterOptions runs
        if (_pendingColor) {
          const colorInput = this.querySelector(
            `fieldset[data-name="Color"] input[value="${_pendingColor}"],
             fieldset[data-name="لون"] input[value="${_pendingColor}"]`
          );
          if (colorInput && !colorInput.checked) {
            colorInput.checked = true;
          }
        }

        this.filterOptions();
      }

      // ✅ Section only becomes visible AFTER correct variant state is fully applied — no flicker
      if (!section.classList.contains('show')) {
        section.classList.add('show');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      this.removeLoader();
      this.applyFallback();
requestAnimationFrame(() => {
  const submitBtn = this.closest('product-info')?.querySelector('button.product-form__submit');
  if (submitBtn) submitBtn.style.opacity = '1';
});
    };

        this.loader = productInfo.querySelector('.loader'); // ✅ moved up — showLoader() needs it

    if (window.ShopifyProduct._loading) {
      document.addEventListener('shopify:variants:loaded', runInitWithColorRestore, { once: true });
    } else {
      runInitWithColorRestore();
    }

    // Update size label if already selected
    if (window.sizeSelected && selectBtn) {
      selectBtn.textContent = window.sizeSelected;
      selectBtn.classList.add('selected');
    }

    // Size popup toggle
    if (selectBtn && !selectBtn.classList.contains('bound')) {
      selectBtn.addEventListener('click', () => {
        sizePopup.style.display = 'block';
      });
      selectBtn.classList.add('bound');
    }
    if (closeBtn && !closeBtn.classList.contains('bound')) {
      closeBtn.addEventListener('click', () => {
        sizePopup.style.display = 'none';
      });
      closeBtn.classList.add('bound');
    }

    this.addEventListener('change', event => {
  const t = this.getInputForEventTarget(event.target);
  const fs = t.closest('fieldset');
  const name = fs?.dataset.name;

  if (name === 'Gender' || name === 'جنس') {
    window.sizeSelected = '';
    this.querySelectorAll('fieldset[data-name="Size"] input[type="radio"], fieldset[data-name="مقاس"] input[type="radio"]').forEach(r => r.checked = false);
    if (selectBtn) {
      if (htmlEl.lang === "ar" && htmlEl.dir === "rtl") {
        selectBtn.textContent = 'اختر الحجم';
      } else {
        selectBtn.textContent = 'Select a size';
      }
      selectBtn.classList.remove('selected');
    }
    sizePopup.style.display = 'none';
    section.classList.remove('show');
    this.showLoader();
  }

  if (name === 'Color' || name === 'لون') {
    window.sizeSelected = '';
    section.classList.remove('show');
    window.removeColorLoader?.();
  }

  if (name === 'Size' || name === 'مقاس') {
    const headerATC = document.querySelector('.product-form-btn');
    const submitBton = document.querySelector('.product-form-btn button[type="submit"]');
    const spinLoad = document.querySelector('.spin-load');
    const spinner = document.querySelector(".product-form-btn .loading__spinner");
    if (submitBton) {
      submitBton.classList.add("hidden");
      spinLoad.classList.remove("hidden");
      spinner?.classList.remove("hidden");
      headerATC.style.textAlign = 'center';
      setTimeout(() => {
        headerATC.style.textAlign = '';
        submitBton.classList.remove("hidden");
        spinLoad.classList.add("hidden");
        spinner?.classList.add("hidden");
      }, 1200);
    }

    if (!t.classList.contains("disabled")) {
      window.sizeSelected = t.value;
      if (selectBtn) {
        selectBtn.textContent = t.value;
        selectBtn.classList.add('selected');
      }
      sizePopup.style.display = 'none';
    } else {
      window.sizeSelected = '';
      if (selectBtn) {
        if (htmlEl.lang === "ar" && htmlEl.dir === "rtl") {
          selectBtn.textContent = 'اختر الحجم';
        } else {
          selectBtn.textContent = 'Select a size';
        }
        selectBtn.classList.remove('selected');
      }
    }

    if (t.classList.contains("disabled")) {
      document.body.classList.add("loader-active");
      waitForElementAndClick(".gw-button-widget, .gw-float-widget");
    }

    function waitForElementAndClick(selector, maxAttempts = 10, interval = 200) {
      let attempts = 0;
      const checkAndClick = () => {
        const element = document.querySelector(selector);
        if (element && typeof element.click === 'function') {
          try {
            element.click();
            document.body.classList.remove("loader-active");
            return true;
          } catch (error) {
            console.warn("Click failed, retrying...", error);
          }
        }
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkAndClick, interval);
        } else {
          console.error("Failed to find or click the element after maximum attempts.");
        }
      };
      checkAndClick();
    }
  }

  // ✅ KEY FIX: if variants are still loading, wait then re-run filterOptions
  const runFilter = () => {
    if (!this.dataset.combined) this.filterOptions();
    this.applyFallback();
  };

  if (window.ShopifyProduct._loading) {
    document.addEventListener('shopify:variants:loaded', runFilter, { once: true });
  } else {
    runFilter();
  }

  this.updateSelectionMetadata(event);
  publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
    data: {
      event,
      target: t,
      selectedOptionValues: this.selectedOptionValues,
      selectedOptions: this.selectedOptions,
    }
  });
});

    // Observer for stock fallback
    const desktopBtn = productInfo.querySelector('button.product-form__submit');
    if (desktopBtn) new MutationObserver(() => {
      let { Gender, Color } = this.selectedOptions;
      let g = Gender || this.selectedOptions["جنس"];
      let c = Color  || this.selectedOptions["لون"];
      const inStock = (window.ShopifyProduct?.variants || []).filter(v => v.options[0] === g && v.options[1] === c && v.available);
      if (inStock.length > 0 && desktopBtn.disabled) this.applyFallback();
    }).observe(desktopBtn, { attributes: true, childList: true, subtree: true });

    document.querySelectorAll('form.add-to-cart-form button').forEach(btn => {
      new MutationObserver(() => {
        let { Gender, Color } = this.selectedOptions;
        let g = Gender || this.selectedOptions["جنس"];
        let c = Color  || this.selectedOptions["لون"];
        const inStock = (window.ShopifyProduct?.variants || []).filter(v => v.options[0] === g && v.options[1] === c && v.available);
        if (inStock.length > 0 && btn.disabled) this.applyFallback();
      }).observe(btn, { attributes: true, childList: true, subtree: true });
    });
  }

  // REPLACE WITH
  filterOptions = (hide = true) => {
    let { Gender, Color } = this.selectedOptions;
    let g = Gender || this.selectedOptions["جنس"];
    let c = Color  || this.selectedOptions["لون"];
    const byG = ShopifyProduct.variants.filter(v => v.options[0] === g);

    if (hide) {
      const colors = [...new Set(byG.map(v => v.options[1]))];
      const productInfo = this.closest('product-info');

      // ✅ Query BOTH original fieldset labels AND cloned mobile fieldset labels
      this.colorOptions = [
        ...this.querySelectorAll('fieldset[data-name="Color"] label.color-swatch, fieldset[data-name="لون"] label.color-swatch'),
        ...(productInfo?.querySelectorAll('[data-linked-to="Color"] label.color-swatch, [data-linked-to="لون"] label.color-swatch') || [])
      ];
      this.colorOptions.forEach(el => el.hidden = !colors.includes(el.dataset.value));

      const sizes = [...new Set(byG.filter(v => v.options[1] === c).map(v => v.options[2]))];

      // ✅ Same for sizes
      this.sizeOptions = [
        ...this.querySelectorAll('fieldset[data-name="Size"] label, fieldset[data-name="مقاس"] label'),
        ...(productInfo?.querySelectorAll('[data-linked-to="Size"] label, [data-linked-to="مقاس"] label') || [])
      ];
      this.sizeOptions.forEach(el => el.hidden = !sizes.includes(el.dataset.value));
    }
    return true;
  }

  applyFallback() {
    const variants = window.ShopifyProduct?.variants || [];
    let { Gender, Color } = this.selectedOptions;
    let g = Gender || this.selectedOptions["جنس"];
    let c = Color  || this.selectedOptions["لون"];
    if (!g || !c) return;

    const inStock = variants.filter(v => v.options[0] === g && v.options[1] === c && v.available);
    const fallback = inStock[0] || null;

    const root = this.closest('product-info');
    if(root){
      const desktopInput = root.querySelector('input.product-variant-id');
      const desktopBtn = root.querySelector('button.product-form__submit');
      if (desktopInput && desktopBtn) {
      if (fallback) {
        desktopInput.value = fallback.id;
        desktopInput.disabled = false;
        desktopBtn.disabled = false;
        if (htmlEl.lang === "ar" && htmlEl.dir === "rtl") {
          desktopBtn.querySelector('span').textContent = 'أضف إلى الحقيبة';
        }
        else {
          desktopBtn.querySelector('span').textContent = 'Add to bag';
        }
      } else {
        desktopInput.value = '';
        desktopInput.disabled = true;
        desktopBtn.disabled = true;
        if (htmlEl.lang === "ar" && htmlEl.dir === "rtl") {
          desktopBtn.querySelector('span').textContent = 'نفذ';
        }
        else {
          desktopBtn.querySelector('span').textContent = 'Sold out';
        }
      }
    }
    }

    

    document.querySelectorAll('form.add-to-cart-form').forEach(form => {
      const input = form.querySelector('input.product-variant-id');
      const btn = form.querySelector('button');
      if (!input || !btn) return;
      if (fallback) {
        input.value = fallback.id;
        input.disabled = false;
        btn.disabled = false;
        if (htmlEl.lang === "ar" && htmlEl.dir === "rtl") {
          btn.textContent = 'أضف إلى الحقيبة';}
        else {
          btn.textContent = 'Add to bag';}
      } else {
        input.value = '';
        input.disabled = true;
        btn.disabled = true;
        if (htmlEl.lang === "ar" && htmlEl.dir === "rtl") {
          btn.textContent = 'نفذ';}
        else {  
        btn.textContent = 'Sold out';
        }
      }
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      target.querySelectorAll('option').forEach(o => o.selected = false);
      target.selectedOptions[0].selected = true;
      const sw = target.closest('.product-form__input').querySelector('[data-selected-value]>.swatch');
      const v = target.selectedOptions[0].dataset.optionSwatchValue;
      if (sw) {
        sw.style.setProperty('--swatch--background', v || 'unset');
        sw.classList.toggle('swatch--unavailable', !v);
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const disp = target.closest('.product-form__input')?.querySelector('[data-selected-value]');
      if (disp) disp.textContent = value;
    }
  }

  showLoader() {
    this.loader?.classList.add('active');
  }

  removeLoader() {
    this.loader?.classList.remove('active');
  }

  getInputForEventTarget(t) {
    return t.tagName === 'SELECT' ? t.selectedOptions[0] : t;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option:checked, fieldset input:checked')).map(el => el.dataset.optionValueId);
  }

  get selectedOptions() {
    return Array.from(this.querySelectorAll('select option:checked, fieldset input:checked')).reduce((a, el) => {
      a[el.closest('fieldset').dataset.name] = el.value;
      return a;
    }, {});
  }
}

customElements.define('variant-selects', VariantSelects);
